export default "<p>point-filter works!</p>\n";